import 'react-image-lightbox/style.css'

import { memo } from 'react'
import { useState } from 'react'
import ReactImageLightbox from 'react-image-lightbox'

function Lightbox(props: LightboxProps) {
  const { images, initialImage, onExit } = props
  const [currentImage, setCurrentImage] = useState(initialImage || 0)

  return (
    <ReactImageLightbox
      mainSrc={images[currentImage]}
      nextSrc={images[(currentImage + 1) % images.length]}
      prevSrc={images[(currentImage + images.length - 1) % images.length]}
      onCloseRequest={onExit}
      onMovePrevRequest={() =>
        setCurrentImage((currentImage + images.length - 1) % images.length)
      }
      onMoveNextRequest={() =>
        setCurrentImage((currentImage + 1) % images.length)
      }
    />
  )
}

interface LightboxProps {
  images: string[]
  initialImage?: number
  onExit(): void
}

export default memo(Lightbox)
